import {
  Card as FumadocsCard,
  Cards as FumadocsCards,
} from "fumadocs-ui/components/card";
import type { ReactNode } from "react";

import { renderMintIcon } from "./icon-map";

type CardProps = {
  title: string;
  icon?: string;
  href?: string;
  children?: ReactNode;
};

type CardGroupProps = {
  cols?: 1 | 2 | 3;
  children: ReactNode;
};

function isExternalHref(href?: string) {
  return href?.startsWith("http://") || href?.startsWith("https://");
}

export function Card({ children, href, icon, title }: CardProps) {
  return (
    <FumadocsCard
      external={isExternalHref(href)}
      href={href}
      icon={icon ? renderMintIcon(icon) : undefined}
      title={title}
    >
      {children}
    </FumadocsCard>
  );
}

export function CardGroup({ children, cols = 2 }: CardGroupProps) {
  const className =
    cols === 1
      ? "docs-card-group !grid-cols-1"
      : cols === 3
        ? "docs-card-group !grid-cols-3"
        : "docs-card-group";

  return <FumadocsCards className={className}>{children}</FumadocsCards>;
}
